module.exports = __webpack_public_path__ + "static/media/pp_boy.87e45862.svg";